var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationNotActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "var(--color-filter-modal-item-border, #F2F4FC)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3248_592258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 24C15 24.7956 15.3161 25.5587 15.8787 26.1213C16.4413 26.6839 17.2044 27 18 27C18.7956 27 19.5587 26.6839 20.1213 26.1213C20.6839 25.5587 21 24.7956 21 24",
    stroke: "var(--text-secondary, #393B42)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.75C11.25 13.9598 11.9611 12.2429 13.227 10.977C14.4929 9.71116 16.2098 9 18 9C19.7902 9 21.5071 9.71116 22.773 10.977C24.0388 12.2429 24.75 13.9598 24.75 15.75C24.75 17.4817 25.2154 19.6213 25.6661 21.2875C26.0274 22.623 25.0439 24 23.6604 24H12.3394C10.956 24 9.97246 22.6231 10.3337 21.2877C10.7845 19.6212 11.25 17.4814 11.25 15.75Z",
    stroke: "var(--text-secondary, #393B42)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3248_592258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNotActive);
export default __webpack_public_path__ + "static/media/notificationNotActive.dba377d1a0a705fd457a771eb6aa545e.svg";
export { ForwardRef as ReactComponent };